/**
 * <InquiryDetailsCard>
 *
 * Inquiry 关键信息卡片。基于 Figma 节点 9281-13838 还原。
 *
 * 视觉结构：
 *  ┌─────────────────────────────────────────────────────────────┐
 *  │ ⚙ Inquiry Details                          [Edit specs]    │
 *  │ ┌─ bg-[#FAFAFA] rounded ───────────────────────────────┐   │
 *  │ │ Product Name | Unit Price  | Quantity                │   │
 *  │ │ Trade terms  | Buyer Name  | Location                │   │
 *  │ └──────────────────────────────────────────────────────┘   │
 *  └─────────────────────────────────────────────────────────────┘
 *
 * Props 契约：
 *   specs/001-agent-progress-figma-rebuild/contracts/ui-contract.md §2
 *
 * ⚠️ FR-005a 强制约束：本组件 MUST NOT 接收 onEditSpecs / editSpecsState 等任何
 * 与 Inquiry specs 编辑相关的 props，DOM 中不得出现 'Edit specs' 文本节点。
 */

import { FC } from 'react';
import cn from 'classnames';
import { Settings2 } from 'lucide-react';
// import { Button } from '@leadsnavi/ui-kit';
import type { InquiryDetailsVM } from '../../types';

export type InquiryDetailsCardProps = {
  vm: InquiryDetailsVM;
  className?: string;
};

export const InquiryDetailsCard: FC<InquiryDetailsCardProps> = ({ vm, className }) => {
  return (
    <section className={cn('h-full border border-[#E5E5E5] rounded-lg p-4 flex flex-col gap-5', className)}>
      {/* Header 行：图标 + 标题 + Edit specs 按钮 */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Settings2 size={18} strokeWidth={1.75} className="text-[#A3A3A3]" />
          <h2 className="text-base font-bold text-[#101828]">Inquiry Details</h2>
        </div>
        {/* <Button variant="outline" size="sm">
          Edit specs
        </Button> */}
      </div>

      {/* 字段网格容器 */}
      <div className="bg-[#FAFAFA] rounded-lg p-4 flex flex-col gap-4">
        {/* 上排 3 列 */}
        <div className="flex gap-4">
          {vm.fields.slice(0, 3).map(field => (
            <div key={field.label} className="flex-1 min-w-0 flex flex-col gap-1">
              <dt className="text-xs font-medium text-[#737373] tracking-wider">{field.label}</dt>
              <dd className="text-sm font-medium text-[#262626] truncate" title={field.value}>
                {field.value}
              </dd>
            </div>
          ))}
        </div>
        {/* 下排 3 列 */}
        <div className="flex gap-4">
          {vm.fields.slice(3, 6).map(field => (
            <div key={field.label} className="flex-1 min-w-0 flex flex-col gap-1">
              <dt className="text-xs font-medium text-[#737373] tracking-wider">{field.label}</dt>
              <dd className="text-sm font-medium text-[#262626] truncate" title={field.value}>
                {field.value}
              </dd>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InquiryDetailsCard;
